export type AvatarBadgePosition = 'bottom-right' | 'top-right';

export const getAvatarBadgeStyles = (avatarSize: number, badgePosition: AvatarBadgePosition) => {
  const maskImage = getAvatarMaskImage(avatarSize, badgePosition);
  const maskStyle = {
    WebkitMaskImage: maskImage,
    maskImage,
    WebkitMaskMode: 'luminance',
    maskMode: 'luminance',
  };

  const { size: badgeSize, x: badgeX, y: badgeY } = getAvatarBadgeDimensions(avatarSize);
  const badgeStyle = {
    [badgePosition === 'bottom-right' ? 'bottom' : 'top']: badgeY,
    right: badgeX,
  };
  const badgeProps = { size: badgeSize, style: badgeStyle, className: 'absolute!' };

  return { maskStyle, badgeProps };
};

const getAvatarMaskImage = (
  avatarSize: number,
  badgePosition: AvatarBadgePosition,
  badgeRadius = 0.32,
) => {
  const { size: badgeSize, x: badgeX, y: badgeY } = getAvatarBadgeDimensions(avatarSize);
  const maskGap = avatarSize / 16;
  const maskSize = badgeSize + maskGap * 2;
  const maskRadius = Math.min(maskSize / 2, badgeSize * badgeRadius + maskGap);

  const maskX = avatarSize - badgeSize - maskGap - badgeX;
  const maskY =
    badgePosition === 'top-right' ? -maskGap + badgeY : avatarSize - badgeSize - maskGap - badgeY;

  return getAvatarMaskImageData(avatarSize, maskSize, maskX, maskY, maskRadius);
};

export const getAvatarMaskImageData = (
  size: number,
  maskSize: number,
  maskX: number,
  maskY: number,
  maskRadius: number,
) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}">
      <rect x="0" y="0" width="${size}" height="${size}" fill="white" />
      <rect x="${maskX}" y="${maskY}" width="${maskSize}" height="${maskSize}" rx="${maskRadius}" ry="${maskRadius}" fill="black" />
    </svg>
  `;

  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

const getAvatarBadgeDimensions = (size: number) => ({
  size: (size * 14) / 36,
  x: -(size / 10),
  y: -(size / 32),
});
